module.exports = __webpack_public_path__ + "img/19.38430c1c.png";